/** Available image format variants used as URL suffixes. */
export enum ImageFormat {
  /**
   *  Expected format 520x320
   *  Displayed as 260x160
   *  Used in related guides in desktop
   *  Used in beginner guides in mobile
   */
  VERTICAL = 'vertical',

  /**
   *  Expected format 600x240
   *  Used in guide detail page, in both mobile and desktop
   */
  LARGE = 'large',

  /**
   *  Expected format 320x160
   *  Used in Posts, both mobile and desktop
   */
  SMALL = 'small',
  /**
   *  Expected format 360x300
   * Used in search when posting a guide
   * Used in mobile in recommended and explore pages, displayed as 120x100
   */
  SMALL_MOBILE = 'smallMobile',

  /**
   *  Expected format 320x200
   * Used in search when posting a guide
   *  Used in recommanded and explore pages in desktop
   */
  SMALL_DESKTOP = 'smallDesktop',
}

/**
 * Appends a format suffix to an image URL before the file extension.
 * @example getImageUrl('https://cdn.example.com/image.jpg', ImageFormat.LARGE) => 'https://cdn.example.com/image_large.jpg'
 */
export function getImageUrl(url: string, format: ImageFormat): string {
  if (!url) return '';

  const lastDot = url.lastIndexOf('.');
  if (lastDot === -1) return `${url}_${format}`;

  const base = url.substring(0, lastDot);
  const ext = url.substring(lastDot);

  return `${base}_${format}${ext}`;
}
